<template>
  <div v-if="isUserAuthenticated">
    <v-dialog/>
    <template>
      <div>
        ...
        <modals-container></modals-container>
      </div>
    </template>

    <!-- Navigation Drawer -->
    <v-navigation-drawer
        app
        :color="drawerBackgroundColor"
        hide-overlay
        style="z-index:300"
        v-if="isUserAuthenticated"
        v-model="sideNav"
        :class="drawerClass">

      <!-- En-tête du drawer avec style environnement -->
      <v-toolbar dense :style="drawerToolbarStyle" :class="drawerHeaderClass">
        <v-toolbar-title class="d-flex align-center">
          <v-icon color="white" class="mr-2">mdi-office-building</v-icon>
          TSA
          <!-- Badge environnement dans le drawer -->
          <v-chip
              v-if="!isProduction"
              :color="environmentChipColor"
              text-color="white"
              x-small
              class="ml-2"
              outlined
          >
            {{ environmentLabel }}
          </v-chip>
        </v-toolbar-title>
      </v-toolbar>

      <!-- Bande colorée d'environnement -->
      <div v-if="!isProduction" :class="drawerBandClass"></div>

      <v-divider></v-divider>

      <!-- Message d'environnement -->
      <v-alert
          v-if="!isProduction"
          :color="environmentChipColor"
          dark
          dense
          class="ma-2"
          border="left"
      >
        <div class="d-flex align-center">
          <v-icon small class="mr-2">{{ environmentIcon }}</v-icon>
          <span class="font-weight-bold">{{ environmentMessage }}</span>
        </div>
      </v-alert>
      <v-list dense>
        <v-list-item :to="'/dashboard'" v-if="userRole==='ADMINISTRATOR'">
          <v-list-item-icon>
            <v-icon>dashboard</v-icon>
          </v-list-item-icon>
          <v-list-item-title>TABLEAU DE BORD</v-list-item-title>
        </v-list-item>
        <v-list>
          <v-list-group :key="item.title"
                        :prepend-icon="item.icon" no-action v-for="item in menuItems" v-model="item.active">
            <template v-slot:[`activator`]>
              <v-list-item-content>
                <v-list-item-title class="text-left" v-text="item.title"></v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
                :key="i"
                :to="subItem.link"
                exact
                link
                v-for="(subItem, i) in item.items"
                @click="redirect(subItem, i)"
            >
              <v-list-item-content>
                <v-list-item-title v-text="subItem.title"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list>
      </v-list>
    </v-navigation-drawer>

    <v-row>
      <!-- Toolbar Desktop -->
      <v-app-bar
          app
          dark
          dense
          :style="toolbarStyle"
          :class="toolbarClass"
          v-if="isUserAuthenticated && isMobile === false">

        <!-- Badge environnement pour desktop -->
        <v-chip
            v-if="!isProduction"
            :color="environmentChipColor"
            text-color="white"
            small
            class="mr-2 font-weight-bold"
        >
          {{ environmentLabel }}
        </v-chip>

        <v-app-bar-nav-icon @click.stop="sideNav = !sideNav"/>
        <v-col>
          <v-toolbar-title>
            <template
                v-if="isUserAuthenticated && userRole==='ADMINISTRATOR' || (getbaseUrl && getbaseUrl !== 'https://tsarh.cartaware.cartalink.com')">
              {{ getbaseUrl }}
            </template>
          </v-toolbar-title>
        </v-col>
        <v-col class="fill-height">
          <v-toolbar-items class="d-none d-sm-flex hidden-xs-only">
            <v-spacer></v-spacer>

            <!-- Bouton QR Code pour Desktop -->
            <v-btn :visible="false" :tile="true" @click="navigateToQRCode" text v-if="showQRCodeButton">
              <v-icon left>mdi-qrcode</v-icon>
              QR Code
            </v-btn>

            <v-btn :tile="true" @click="displayNotifs" text>
              <v-badge
                  :content="this.$store.getters.notification"
                  :value="this.$store.getters.notification"
                  bottom
                  color="red"
                  left
                  overlap
              >
                <v-icon>
                  mdi-bell-ring-outline
                </v-icon>
              </v-badge>
            </v-btn>
            <v-btn :tile="true" text>
              <v-icon left>mdi-account</v-icon>
              {{ getName }}
            </v-btn>
            <v-btn @click="onLogout" text>
              <v-icon left>mdi-lock-outline</v-icon>
              Déconnexion
            </v-btn>
          </v-toolbar-items>
        </v-col>
      </v-app-bar>

      <!-- Toolbar Mobile -->
      <v-app-bar
          app
          dark
          dense
          :style="toolbarStyle"
          :class="toolbarClass"
          v-if="isUserAuthenticated && isMobile === true">

        <!-- Badge environnement pour mobile -->
        <v-chip
            v-if="!isProduction"
            :color="environmentChipColor"
            text-color="white"
            x-small
            class="mr-1"
        >
          {{ environmentLabel }}
        </v-chip>

        <v-app-bar-nav-icon @click.stop="sideNav = !sideNav"/>
        <v-spacer/>

        <!-- Bouton QR Code pour Mobile -->
        <v-btn :visible="false" @click="navigateToQRCode" text v-if="showQRCodeButton">
          <v-icon>mdi-qrcode</v-icon>
        </v-btn>

        <v-btn @click="onLogout" text>
          <v-icon left>mdi-lock-outline</v-icon>
          Déconnexion
        </v-btn>
      </v-app-bar>
    </v-row>

    <!-- Tous les modals existants restent identiques -->
    <vue-final-modal v-model="showModalComptes" classes="modal-container" content-class="modal-content" :min-width="800"
                     :click-to-close="false" :z-index-auto="true"
                     :lock-scroll="true" :focus-retain="true" :drag="true" :ssr="true">
      <span class="modal__title">Aide pour la gestion des Comptes</span>
      <div class="modal__content">
        <v-card width="800">
          <v-container>
            <v-card-text>
              <v-row class="justify-center align-center">
                <template>
                  <VueFaqAccordion :items="myItemsComptes" activeColor="#01579B" borderColor="#01579B"
                                   fontColor="#757579"/>
                </template>
              </v-row>
            </v-card-text>
            <v-card-text>
              <v-row class="justify-center align-center">
                <v-btn @click="quitComptes"
                       class="v-btnRefresh"
                       color="#01579B"
                       depressed
                       outlined
                       style="font-weight: bold"
                       width="120">Fermer
                </v-btn>
              </v-row>
            </v-card-text>
          </v-container>
        </v-card>
      </div>
    </vue-final-modal>

    <vue-final-modal v-model="showModalFonction" classes="modal-container" content-class="modal-content"
                     :min-width="800" :click-to-close="false" :z-index-auto="true"
                     :lock-scroll="true" :focus-retain="true" :drag="true" :ssr="true">
      <span class="modal__title">Aide pour la gestion des Fonctions</span>
      <div class="modal__content">
        <v-card width="800">
          <v-container>
            <v-card-text>
              <v-row class="justify-center align-center">
                <template>
                  <VueFaqAccordion :items="myItemsFonction" activeColor="#01579B" borderColor="#01579B"
                                   fontColor="#757579"/>
                </template>
              </v-row>
            </v-card-text>
            <v-card-text>
              <v-row class="justify-center align-center">
                <v-btn @click="quitFonction"
                       class="v-btnRefresh"
                       color="#01579B"
                       depressed
                       outlined
                       width="120">Fermer
                </v-btn>
              </v-row>
            </v-card-text>
          </v-container>
        </v-card>
      </div>
    </vue-final-modal>

    <vue-final-modal v-model="showModalBrigade" classes="modal-container" content-class="modal-content" :min-width="800"
                     :click-to-close="false" :z-index-auto="true"
                     :lock-scroll="true" :focus-retain="true" :drag="true" :ssr="true">
      <span class="modal__title">Aide pour la gestion des Brigades</span>
      <div class="modal__content">
        <v-card width="800">
          <v-container>
            <v-card-text>
              <v-row class="justify-center align-center">
                <template>
                  <VueFaqAccordion :items="myItemsBrigade" activeColor="#01579B" borderColor="#01579B"
                                   fontColor="#757579"/>
                </template>
              </v-row>
            </v-card-text>
            <v-card-text>
              <v-row class="justify-center align-center">
                <v-btn @click="quitBrigade"
                       class="v-btnRefresh"
                       color="#01579B"
                       depressed
                       outlined
                       width="120">Fermer
                </v-btn>
              </v-row>
            </v-card-text>
          </v-container>
        </v-card>
      </div>
    </vue-final-modal>

    <vue-final-modal v-model="showModalRaisonsAbsence" classes="modal-container" content-class="modal-content"
                     :min-width="800" :click-to-close="false" :z-index-auto="true"
                     :lock-scroll="true" :focus-retain="true" :drag="true" :ssr="true">
      <span class="modal__title">Aide pour la gestion des Raisons d'absence</span>
      <div class="modal__content">
        <v-card width="800">
          <v-container>
            <v-card-text>
              <v-row class="justify-center align-center">
                <template>
                  <VueFaqAccordion :items="myItemsRaisonsAbsence" activeColor="#01579B" borderColor="#01579B"
                                   fontColor="#757579"/>
                </template>
              </v-row>
            </v-card-text>
            <v-card-text>
              <v-row class="justify-center align-center">
                <v-btn @click="quitRaisonsAbsence"
                       class="v-btnRefresh"
                       color="#01579B"
                       depressed
                       outlined
                       width="120">Fermer
                </v-btn>
              </v-row>
            </v-card-text>
          </v-container>
        </v-card>
      </div>
    </vue-final-modal>

    <vue-final-modal v-model="showModalPlanning" classes="modal-container" content-class="modal-content"
                     :min-width="800" :click-to-close="false" :z-index-auto="true"
                     :lock-scroll="true" :focus-retain="true" :drag="true" :ssr="true">
      <span class="modal__title">Aide pour la gestion des Planning</span>
      <div class="modal__content">
        <v-card width="800">
          <v-container>
            <v-card-text>
              <v-row class="justify-center align-center">
                <template>
                  <VueFaqAccordion :items="myItemsPlanning" activeColor="#01579B" borderColor="#01579B"
                                   fontColor="#757579"/>
                </template>
              </v-row>
            </v-card-text>
            <v-card-text>
              <v-row class="justify-center align-center">
                <v-btn @click="quitPlanning"
                       class="v-btnRefresh"
                       color="#01579B"
                       depressed
                       outlined
                       width="120">Fermer
                </v-btn>
              </v-row>
            </v-card-text>
          </v-container>
        </v-card>
      </div>
    </vue-final-modal>

    <modal :adaptive=true
           :clickToClose="false"
           :draggable=false
           :resizable=false
           height="auto"
           name="modal-fade-info">
      <v-card>
        <v-container>
          <v-card-text>
            <template @mouseleave.native="hover = false" @mouseover.native="hover = true">
              <v-row class="justify-center align-center">
                <h2 style="color:red">La nouvelle version V{{ this.versionFrontOnServer }} de
                  l'application est disponible.</h2>
                <h3 style="color:dimgrey"><br/>Voulez-vous l'installer 'Maintenant' ou 'Plus tard'
                  ?.<br/><br/></h3>
              </v-row>
              <v-row class="justify-center align-center">
                <v-btn @click="annuler"
                       class="v-btnRefresh"
                       color="#01579B"
                       depressed
                       outlined
                       width="120">Plus tard
                </v-btn>

                <v-btn @click="refreshPage"
                       class="v-btnRefresh"
                       color="#009688"
                       depressed
                       outlined
                       width="120">Maintenant
                </v-btn>
              </v-row>
            </template>
          </v-card-text>
        </v-container>
      </v-card>
    </modal>
  </div>
</template>

<script>
import apiClient from "../config/api.js";
import packageInfo from '../../package.json'
import 'vue-js-modal/dist/styles.css'
import VueFaqAccordion from "vue-faq-accordion"; //https://github.com/gerasimvol/vue-faq-accordion
import {$vfm, VueFinalModal, ModalsContainer} from 'vue-final-modal'
import {compare} from "compare-versions";

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  components: {VueFaqAccordion, VueFinalModal, ModalsContainer},
  data() {
    return {
      navigationInProgress: false,
      isMobile: isMobileDevice(),

      items3D: [{title: 'Comptes', click: () => this.showComptes()}, {
        title: 'Fonction',
        click: () => this.showFunction()
      },
        {title: 'Brigade', click: () => this.showBrigade()}, {
          title: 'Raisons absence',
          click: () => this.showRaisonsAbsence()
        },
        {title: 'Planning', click: () => this.showPlanning()}],
      myItemsComptes: [
        {
          title: '<h3>Création du compte principal</h3>',
          value: '<h4>Allez dans le menu \'COMPTES\' puis sélectionnez le sous menu \'Agents\'. <br/>Cliquez sur le button \'CRÉATION AGENT\' et renseignez ' +
              'le Matricule, le Nom, le Prénom, l\'Adresse*, le Téléphone*, la Brigade et la Fonction puis validez en appuyant sur le bouton \'CRÉER AGENT\'. <br/>' +
              'Vous pouvez aussi créer des comptes principaux en masse grâce au chargement d\'un fichier excel dont le modèle est donné en appuyant sur le bouton \'EXPORT MODÈLE\'.<br/>' +
              'Pour ce faire et après avoir créé votre fichier d\'employés nouveaux, Allez à \'CRÉATION AGENT\' et Choisissez l\'onglet \'Via un fichier excel\'.<br/>' +
              'Faites soit un glisser/coller de votre fichier sur la parti en surbrillance (jaune), soit Recherchez le fichier via le bouton \'Importer le fichier\' puis Valider ' +
              'en cliquant sur le nuage vert.<br/><br/>' +
              '<span style="color:pink;">Les rubriques avec un astérisque (*) sont optionnels.</span><br/>' +
              '<span style="color:darkgreen;">Le modèle du fichier pour l\'importation en masse doît être scrupuleusement suivi sinon il sera rejeté.</span><br/>' +
              '<span style="color:darkgreen">Si vous souhaitez abandonner la création du compte principal, cliquez sur la croix noire en haut de la fenêtre.</span><br/>' +
              '<span style="color:red;">Seule Corinne est habilitée à créer des comptes.</span></h4><br/>' +
              '<a href="https://drive.google.com/file/d/1fP9HXjpWGuOFsNYz0HLIZI4Xb6EOPx_t/view?usp=sharing" title="Capture écran Création compte principal" target="_blank">Capture écran \'Création compte\'</a><br/>' +
              '<a href="https://drive.google.com/file/d/16Ea_HmfSPajQNyyBDepFJ71PwSrccsAD/view?usp=sharing" title="Capture écran Abandon création" target="_blank">Capture écran \'Abandon création\'</a><br/>' +
              '<a href="https://drive.google.com/file/d/1Hckbw34tTDglljPTW31A0-shV27Wj79l/view?usp=sharing" title="Capture écran Création en masse" target="_blank">Capture écran \'Création en masse\'</a>',
          category: '<h2>Création</h2>'
        },
        {
          title: '<h3>Création du compte secondaire</h3>',
          value: '<h4>Allez dans le menu \'COMPTES\' puis sélectionnez le sous menu \'Détails\'.<br/><br/>Cliquez sur le button \'CRÉATION DÉTAILS\' et renseignez<br/>' +
              ' <span style="color:green;"><strong>  -</strong></span> Le Statut à savoir le Matricule, le Genre, le Statut, le Nombre d\'enfants, la Date de naissance, la Lieu de naissance<br/> ' +
              ' <span style="color:green;"><strong>  -</strong></span> Le Contrat à savoir le Type de contrat, La Date de début du contrat, la Date de fin du contrat<br/> ' +
              ' <span style="color:green;"><strong>  -</strong></span> La Liste des certifications à savoir les numéros de certifications suivi des catégories certifiées<br/>' +
              ' <span style="color:green;"><strong>  -</strong></span> La Date des certifications à savoir la Date X-Ray, la Date Base, La date MDR et la Date de Formation<br/>' +
              ' <span style="color:green;"><strong>  -</strong></span> Les Autres infos à savoir les Autres formations, le Niveau de formation, la Ligne du bus, l\'Arrêt du bus, la Taille, la Pointure, la Taille Chemise,' +
              'la Taille jupe, la Taille pantalon de l\'agent <br/>' +
              'puis validez en appuyant sur le bouton \'CRÉER DÉTAILS\'.<br/>' +
              'Vous pouvez aussi créer des comptes secondaires en masse grâce au chargement d\'un fichier excel dont le modèle est donné en appuyant sur le bouton \'EXPORT MODÈLE\'.<br/>' +
              'Pour ce faire et après avoir créé votre fichier d\'employés dont le compte principal existe, Allez à \'CRÉATION DÉTAILS\' et Choisissez l\'onglet \'Via un fichier excel\'.<br/>' +
              'Faites soit un glisser/coller de votre fichier sur la parti en surbrillance (jaune), soit Recherchez le fichier via le bouton \'Importer le fichier\' puis Valider ' +
              'en cliquant sur le nuage vert.<br/><br/>' +
              '<span style="color:pink;">Tout est optionnel sauf le matricule et le genre.</span><br/>' +
              '<span style="color:red;">Un compte secondaire ne peut être créé que si le compte principal associé existe.</span><br/>' +
              '<span style="color:darkgreen;">Le modèle du fichier pour l\'importation en masse doît être scrupuleusement suivi sinon il sera rejeté.</span><br/>' +
              '<span style="color:darkgreen">Si vous souhaitez abandonner la création du compte secondaire, cliquez sur la croix noire en haut de la fenêtre.</span></h4><br/>' +
              '<a href="https://drive.google.com/file/d/1KGuRxHPiLNC34eEE31AnvPhP_VuZJ569/view?usp=sharing" title="Capture écran Ajout compte secondaire (1)" target="_blank">Capture écran \'Ajout compte secondaire (1)\'</a><br/>' +
              '<a href="https://drive.google.com/file/d/1Uy1vI44W-MCJ_Ffw2o0Yuq1ecoKKYam1/view?usp=sharing" title="Capture écran Ajout compte secondaire (2)" target="_blank">Capture écran \'Ajout compte secondaire (2)\'</a><br/>' +
              '<a href="https://drive.google.com/file/d/1a29QIOQeubUO1tpNJss9n7-bW6wIxNvk/view?usp=sharing" title="Capture écran Abandon saisie compte secondaire" target="_blank">Capture écran \'Abandon saisie compte secondaire\'</a><br/>' +
              '<a href="https://drive.google.com/file/d/1IauXAetz_VcSNPKanXS0Hjr0HLVQ_An6/view?usp=sharing" title="Capture écran Création secondaires en masse" target="_blank">Capture écran \'Création comptes secondaires en masse\'</a>',
          category: '<h2>Création</h2>'
        },
        {
          title: '<h3>Modification du compte principal</h3>',
          value: '<h4>Allez dans le menu \'COMPTES\' puis sélectionnez le sous menu \'Agents\'. <br/>' +
              'Sélectionnez l\'employé à modifier puis Cliquez sur le button droit de la souris. Un menu contextuel apparaîtra puis Choisissez \'Modifier\'. <br/>' +
              'Modifiez les informations de l\'employé puis valider avec le bouton \'MODIFIER AGENT\'. <br/><br/>' +
              '<span style="color:pink;">Toutes les informations sont modifiables sauf le matricule.</span><br/>' +
              '<span style="color:darkgreen">Si vous souhaitez abandonner la saisie, cliquez sur la croix noire en haut de la fenêtre.</span></h4><br/>' +
              '<a href="https://drive.google.com/file/d/1EWOQnPybTtVh3FX_XvGwDdA4Rz6I2HUT/view?usp=sharing" title="Capture écran Modification compte principal (1)" target="_blank">Capture écran \'Modification compte principal (1)\'</a><br/>' +
              '<a href="https://drive.google.com/file/d/150Xu8i3tknTTclFJd9X_OKCfW4H9Pn5j/view?usp=sharing" title="Capture écran Modification compte principal (2)" target="_blank">Capture écran \'Modification compte principal (2)\'</a><br/>' +
              '<a href="https://drive.google.com/file/d/16Ea_HmfSPajQNyyBDepFJ71PwSrccsAD/view?usp=sharing" title="Capture écran Abandon modification" target="_blank">Capture écran \'Abandon modification\'</a>',
          category: '<h2>Modification</h2>'
        },
        {
          title: '<h3>Modification du compte secondaire</h3>',
          value: '<h4>Allez dans le menu \'COMPTES\' puis sélectionnez le sous menu \'Agents\'. <br/>' +
              'Sélectionnez l\'employé à modifier puis Cliquez sur le button droit de la souris. Un menu contextuel apparaîtra puis Choisissez \'Modifier\'. <br/>' +
              'Modifiez les informations de l\'employé puis valider avec le bouton \'MODIFIER AGENT\'. <br/><br/>' +
              '<span style="color:pink;">Toutes les informations sont modifiables sauf le matricule.</span><br/>' +
              '<span style="color:darkgreen">Si vous souhaitez abandonner la saisie, cliquez sur la croix noire en haut de la fenêtre.</span></h4><br/>' +
              '<a href="https://drive.google.com/file/d/17xJI5hcXNkp_ShoxdASMNbSlhnpo-Bam/view?usp=sharing" title="Capture écran Modification compte secondaire (1)" target="_blank">Capture écran \'Modification compte secondaire (1)\'</a><br/>' +
              '<a href="https://drive.google.com/file/d/1XrumE6BAAvzbEHStpSk2eJZ9K0bEHyua/view?usp=sharing" title="Capture écran Modification compte secondaire (2)" target="_blank">Capture écran \'Modification compte secondaire (2)\'</a><br/>' +
              '<a href="https://drive.google.com/file/d/1a29QIOQeubUO1tpNJss9n7-bW6wIxNvk/view?usp=sharing" title="Capture écran Abandon modification" target="_blank">Capture écran \'Abandon modification\'</a>',
          category: '<h2>Modification</h2>'
        },
        {
          title: '<h3>Suppression compte principal</h3>',
          value: '<h4>Allez dans le menu \'COMPTES\' puis sélectionnez le sous menu \'Détails\'. <br/>' +
              'Sélectionnez l\'employé à supprimer puis Cliquez sur le button droit de la souris. Un menu contextuel apparaîtra puis Choisissez \'Supprimer\'. <br/>' +
              'Confirmez la suppression lorsqu\'une petite fenêtre apparaitra. <br/><br/>' +
              '<span style="color:red;">Seule Corinne est habilitée à supprimer un compte principal.</span></h4><br/>' +
              '<a href="https://drive.google.com/file/d/1fuDTTKgZv4sudbtOBASlRd_ADfYke6aZ/view?usp=sharing" title="Capture écran Suppression compte principal" target="_blank">Capture écran \'Suppression compte principal\'\'</a>',
          category: '<h2>Suppression</h2>'
        },
        {
          title: '<h3>Suppression compte secondaire</h3>',
          value: '<h4>Allez dans le menu \'COMPTES\' puis sélectionnez le sous menu \'Détails\'. <br/>' +
              'Sélectionnez l\'employé à supprimer puis Cliquez sur le button droit de la souris. Un menu contextuel apparaîtra puis Choisissez \'Supprimer\'. <br/>' +
              'Confirmez la suppression lorsqu\'une petite fenêtre apparaitra. <br/><br/>' +
              '<span style="color:red;">Seule Corinne est habilitée à supprimer un compte seconfaire.</span></h4><br/>' +
              '<a href="https://drive.google.com/file/d/1mwvUOu9p_CFMXGz3yHaloTOvCHYe36qH/view?usp=sharing" title="Capture écran Suppression compte secondaire" target="_blank">Capture écran \'Suppression compte secondaire\'</a>',
          category: '<h2>Suppression</h2>'
        },
        {
          title: '<h3>Désactivation compte</h3>',
          value: '<h4>Allez dans le menu \'COMPTES\' puis sélectionnez le sous menu \'Détails\'. <br/>' +
              'Sélectionnez l\'employé à désativer puis Cliquez sur le button droit de la souris. Un menu contextuel apparaîtra puis Choisissez \'Modifier\'. <br/>' +
              'Allez dans la Rubrique \'2 - Contrat\' puis Renseignez la Date de fin de contrat ou la Date réelle de départ selon l\'information dont vous disposez.<br/>' +
              'Renseigner la raison du départ si vous la connaissez puis validez la modification en cliquant sur le bouton \'Modifier Détails\'. <br/><br/>' +
              '<span style="color:red;">Faites très attention en renseignant les dates de fin car toutes les présences liées à cet agent seront supprimées au lendemain des dates fournies.</span></h4><br/>' +
              '<a href="https://drive.google.com/file/d/1M7ioJZhVAKVtH2oIPrZGZ9FL_nk6zVv0/view?usp=sharing" title="Capture écran Désativation compte" target="_blank">Capture écran \'Désactivation compte\'</a>',
          category: '<h2>Suppression</h2>'
        },
        {
          title: '<h3>Astuce n° 1</h3>',
          value: '<h4>Vous pouvez modifier les informations du compte principal ou secondaire d\'un employé en cliquant simplement sur une case du tableau et en renseignant la nouvelle donnée. </h4>',
          category: '<h2>Astuces</h2>'
        },
        {
          title: '<h3>Astuce n° 2</h3>',
          value: '<h4>Un zone de Recherche est disponible pour vous permettre de trouver une information bien précise.<br/>' +
              'Après la recherche, Appuyez sur la petite croix à droite de la zone de Recherche pour recharger l\'ensemble des données.</h4>',
          category: '<h2>Astuces</h2>'
        },
        {
          title: '<h3>Astuce n° 3</h3>',
          value: '<h4>Les tableaux ont des filtres qui vous permettront de trier, de sélectionner ou d\'isoler tout ou partie des lignes concernées.<br/>' +
              'Ces filtres, qui s\'utilisent de la même manière que eux d\'excel, sont très utiles et très efficaces.</h4>',
          category: '<h2>Astuces</h2>'
        },
        {
          title: '<h3>Astuce n° 4</h3>',
          value: '<h4>Si vous êtes plus à l\'aise sur Excel, cette plateforme vous offre la possibilité de télécharger les lignes sélectionnées en les choisissant au préalable' +
              'puis en appuyant sur les boutons \'EXPORT AGENTS\' ou \'EXPORT DÉTAILS\'. Un fichier Excel sera ainsi téléchargé sur votre ordinateur habituellement dans le dossier \'Téléchargement\'.</h4>',
          category: '<h2>Astuces</h2>'
        }
      ],
      myItemsFonction: [
        {
          title: '<h3>Fonction ou rôle de l\'employé dans l\'entreprise</h3>',
          value: '<h4>Allez dans le menu \'COMPTES\' puis sélectionnez le sous menu \'Rôles\'. Vous verrez la liste des fonctions disponibles.<br/><br/>' +
              '<span style="color:red;">Seule Corinne est habilitée à rajouter ou désactiver une fonction.</span></h4><br/>' +
              '<a href="https://ibb.co/b5Fdjy0" title="Capture écran Fonctions" target="_blank">Capture écran \'Fonctions\'</a>',
          category: '<h2>Fonction</h2>'
        }
      ],
      myItemsBrigade: [
        {
          title: '<h3>Brigade d\'affectation d\'un agent</h3>',
          value: '<h4>Allez dans le menu \'COMPTES\' puis sélectionnez le sous menu \'Brigades\'. Vous verrez la liste des brigades disponibles.<br/><br/>' +
              '<span style="color:red;">Seule Corinne est habilitée à rajouter ou désactiver une brigade.</span></h4><br/>' +
              '<a href="https://ibb.co/rsQQjMj" title="Capture écran Brigades" target="_blank">Capture écran \'Brigades\'</a>',
          category: '<h2>Brigade</h2>'
        }
      ],
      myItemsRaisonsAbsence: [
        {
          title: '<h3>Raisons d\'absence d\'un agent</h3>',
          value: '<h4>Allez dans le menu \'COMPTES\' puis sélectionnez le sous menu \'Raisons absence\'. Vous verrez la liste des types d\'absence disponibles.<br/><br/>' +
              '<span style="color:red;">Seule Corinne est habilitée à rajouter ou désactiver un type d\'absence.</span></h4><br/>' +
              '<a href="https://ibb.co/dPqV8Q4" title="Capture écran Raisons absence" target="_blank">Capture écran \'Raisons absence\'</a>',
          category: '<h2>Raisons absence</h2>'
        }
      ],
      myItemsPlanning: [
        {
          title: '<h3>Création d\'une présence</h3>',
          value: '<h4>Allez dans le menu \'PLANNINGS\' puis sélectionnez le sous menu \'Planning présences\'. <br/>Cliquez sur le button \'NOUVELLE PRÉSENCE\' et renseignez ' +
              'le Matricule, le Shift, la Date de début de shift et l\'Observation* puis validez en appuyant sur le bouton \'CRÉER PRÉSENCE\'. <br/>' +
              'L\'Heure de fin du début du shift ainsi que la date et heure de fin de shift sont automatiquement complétées.<br/>' +
              'Vous pouvez aussi créer des plannings présence en masse grâce au chargement d\'un fichier excel dont le modèle est donné en appuyant sur le bouton \'EXPORT MODÈLE\'.<br/>' +
              'Pour ce faire et après avoir créé votre fichier d\'employés nouveaux, Allez à \'CRÉATION AGENT\' et Choisissez l\'onglet \'Via un fichier excel\'.<br/>' +
              'Faites soit un glisser/coller de votre fichier sur la parti en surbrillance (jaune), soit Recherchez le fichier via le bouton \'Importer le fichier\' puis Valider ' +
              'en cliquant sur le nuage vert.<br/>' +
              'La colonne \'Statut agent\' vous permet de voir en temps réel le statut de la présence d\'un agent qui est soit \'Pointage en attente\' ou \'Présence constatée\'.<br/>' +
              'Il n\'est pas possible de rentrer 2 shifts différents pour une même date et pour un agent donné.<br/>' +
              '<span style="color:pink;">Les rubriques avec un astérisque (*) sont optionnels.</span><br/>' +
              '<span style="color:darkgreen;">Le modèle du fichier pour l\'importation en masse doît être scrupuleusement suivi sinon il sera rejeté.</span><br/>' +
              '<span style="color:darkgreen">Si vous souhaitez abandonner la création d\'une présence, cliquez sur la croix noire en haut de la fenêtre.</span></h4><br/>' +
              '<a href="https://drive.google.com/file/d/1wyylBC2WSic5VORzvtTvhUo97lfdKUY-/view?usp=sharing" title="Capture écran Création présence" target="_blank">Capture écran \'Création présence\'.</a>',
          category: '<h2>Création</h2>'
        },
        {
          title: '<h3>Création d\'une absence</h3>',
          value: '<h4>Allez dans le menu \'PLANNINGS\' puis sélectionnez le sous menu \'Planning absences\'.<br/><br/>Cliquez sur le button \'NOUVELLE ABSENCE\' et renseignez<br/>' +
              'le Matricule, la Raison, la Date de début de shift, la Date de fin de shift et l\'Observation* puis validez en appuyant sur le bouton \'CRÉER ABSENCE\'.<br/>' +
              'La colonne \'En Cours\' permet en un coup d\'oeil de voir si l\'agent en question est absent à la date du jour.<br/>' +
              'La colonne \'Nbre jours total\' vous permet de vérifier si le nombre de jours posés correspond à la réalité.<br/>' +
              'La colonne \'Nbre jours restants\' vous permet de suivre le nombre de jours d\'absence restants par rapport à la date du jour.<br/>' +
              'Il n\'est pas permis de rentrer des dates qui se chevauchent pour un agent.<br/>' +
              '<span style="color:pink;">Les rubriques avec un astérisque (*) sont optionnels.</span><br/>' +
              '<span style="color:red">Attention : Pour une absence d\'un jour, la date de début doit être égale à la date de fin.</span><br/>' +
              '<span style="color:darkgreen">Si vous souhaitez abandonner la création d\'une absence, cliquez sur la croix noire en haut de la fenêtre.</span></h4><br/>' +
              '<a href="https://drive.google.com/file/d/1pUOIU6f8wHKZ_THTqXYrVHvMNba95zoy/view?usp=sharing" title="Capture écran Création absence" target="_blank">Capture écran \'Création absence\'</a>',
          category: '<h2>Création</h2>'
        },
        {
          title: '<h3>Création d\'un planning brigade</h3>',
          value: '<h4>Allez dans le menu \'PLANNINGS\' puis sélectionnez le sous menu \'Planning brigades\'.<br/><br/>Cliquez sur le button \'NOUVEAU PLANNING\' et renseignez<br/>' +
              'la Brigade, le Shift et la Date de début de shift puis validez en appuyant sur le bouton \'CRÉER PLANNING\'.<br/>' +
              'En positionnant une brigade sur un shift, c\'est tous les agents liés à cette brigade qui se voient créer une présence pour ce shift.<br/>' +
              'Pour faire un planning mensuel, il faut mieux utiliser ce menu qui évite de devoir saisir les présences, agent par agent.<br/>' +
              'Il n\'est pas permis de rentrer des dates qui se chevauchent pour une brigade.<br/>' +
              '<span style="color:darkgreen">Si vous souhaitez abandonner la création d\'un planning brigade, cliquez sur la croix noire en haut de la fenêtre.</span></h4><br/>' +
              '<a href="https://drive.google.com/file/d/1DB-njtTcqtlokcZJ62DkodzPvRcg8-gV/view?usp=sharing" title="Capture écran Création planning brigade" target="_blank">Capture écran \'Création planning brigade\'</a>',
          category: '<h2>Création</h2>'
        },
        {
          title: '<h3>Modification d\'une présence</h3>',
          value: '<h4><span style="color:darkgreen;">Il n\'est pas possible de modifier une présence. Il faut la supprimer et la recréer si besoin.</span></h4>',
          category: '<h2>Modification</h2>'
        },
        {
          title: '<h3>Modification d\'une absence</h3>',
          value: '<h4>Il y\'a 3 champs qui peuvent être modifiés directement. Il s\'agit de \'Date de début\', \'Date de fin\', \'Raison absence\' et \'Observations\'.<br/>' +
              'La colonne \'Heures Supp\' contient la liste des Heures supplémentaires qui sont créées via un autre menu.<br/>' +
              'Attention, la \'Date de début\' ne doit pas être supérieure à la \'Date de Fin\'.</h4>',
          category: '<h2>Modification</h2>'
        },
        {
          title: '<h3>Modification d\'un planning brigade</h3>',
          value: '<h4><span style="color:darkgreen;">Il n\'est pas possible de modifier un planning brigade. Il faut le supprimer et le recréer si besoin.</span></h4>',
          category: '<h2>Modification</h2>'
        },
        {
          title: '<h3>Suppression d\'une présence</h3>',
          value: '<h4>Allez dans le menu \'PLANNINGS\' puis sélectionnez le sous menu \'Planning présences\'. <br/>' +
              'Sélectionnez l\'employé à supprimer puis Cliquez sur le button droit de la souris. Un menu contextuel apparaîtra puis Choisissez \'Supprimer\'. <br/>' +
              'Confirmez la suppression lorsqu\'une petite fenêtre apparaitra.</h4>',
          category: '<h2>Suppression</h2>'
        },
        {
          title: '<h3>Suppression d\'une absence</h3>',
          value: '<h4>Allez dans le menu \'PLANNINGS\' puis sélectionnez le sous menu \'Planning absences\'. <br/>' +
              'Sélectionnez l\'employé à supprimer puis Cliquez sur le button droit de la souris. Un menu contextuel apparaîtra puis Choisissez \'Supprimer\'. <br/>' +
              'Confirmez la suppression lorsqu\'une petite fenêtre apparaitra.</h4>',
          category: '<h2>Suppression</h2>'
        },
        {
          title: '<h3>Suppression d\'un planning brigade</h3>',
          value: '<h4>Allez dans le menu \'PLANNINGS\' puis sélectionnez le sous menu \'Planning brigades\'. <br/>' +
              'Sélectionnez la brigade à supprimer puis Cliquez sur le button droit de la souris. Un menu contextuel apparaîtra puis Choisissez \'Supprimer\'. <br/>' +
              'Confirmez la suppression lorsqu\'une petite fenêtre apparaitra.<br/>' +
              '<span style="color:red">Attention, la suppression d\'une brigade, supprime toutes les présences des agents liés à cette brigade pour le jour et l\'heure retenus.</span></h4>',
          category: '<h2>Suppression</h2>'
        },
        {
          title: '<h3>Astuce n° 1</h3>',
          value: '<h4>Les boutons \'Profondeur\' et \'Hauteur\' vous permettent d\'afficher un nombre restreint de lignes. Sans cela vous risquez de charger toute la base de données,' +
              ' ce qui ralentirait fortement l\'affichage. Il est donc souhaitable que vous ne choisissiez que l\'option qui correspond à votre recherche.<br/>' +
              'Exp : Si vous travaillez avec les données du jour, choisissez la Profondeur \'Aujourd\'hui\', avec les données d\'hier, choisissez la Profondeur \'Hier\' et ainsi de suite.</h4>',
          category: '<h2>Astuces</h2>'
        },
        {
          title: '<h3>Astuce n° 2</h3>',
          value: '<h4>Les boutons \'Profondeur\' et \'Hauteur\' vous permettent d\'afficher un nombre restreint de lignes. Sans cela vous risquez de charger toute la base de données,' +
              ' ce qui ralentirait fortement l\'affichage. Il est donc souhaitable que vous ne choisissiez que l\'option qui correspond à votre recherche.<br/>' +
              'Exp : Si vous travaillez avec les données du jour, choisissez la Profondeur \'Aujourd\'hui\', avec les données d\'hier, choisissez la Profondeur \'Hier\' et ainsi de suite.</h4>',
          category: '<h2>Astuces</h2>'
        }
      ],
      updateAvailable: false,
      serverVersion: null,
      intervalFrontTimer: 300000, // Every 5 min
      appVersion: packageInfo.version,
      click: undefined,
      clickType: 'Click or Doubleclick ME',
      timer: '',
      timerRefreshFront: '',
      versionFrontOnServer: '',
      fullNotifArrayNotRead: [[]], // Text, Id
      activeClass: 'active',
      selectedIndex: 1,
      drawer: null,
      version: "1.0",
      sideNav: false,
      title: "",
      permanent: true,
      showModalComptes: false,
      showModalFonction: false,
      showModalBrigade: false,
      showModalRaisonsAbsence: false,
      showModalPlanning: false,
      roles: []
    };
  },
  mounted() {
    //console.log(this.$store.getters.notification);

  },
  watch: {
    $route: function (value) {
      this.title = value.name || "";
    },
  },
  beforemount() {
    this.title = this.$route.meta.title || "";
  },
  computed: {
    getbaseUrl() {
      return this.$store.getters.user ? this.$store.getters.user.baseUrl : '';
    },
    currentPage() {
      return this.$route.path
    },
    navState() {
      return this.isActive ? 'v-item--active' : '';
    },
    getName() {
      return sessionStorage.getItem("name")
    },

    // Nouvelle computed property pour déterminer si le bouton QR Code doit être affiché
    showQRCodeButton() {
      // Cacher le bouton QR Code pour la compagnie TSA
      if (process.env.VUE_APP_APP_COMPANY_NAME === 'TSA') {
        return false;
      }
      
      // Pour les autres compagnies, afficher le bouton sauf pour les rôles FRONT et TPE
      return this.isUserAuthenticated && !['FRONT', 'TPE'].includes(this.userRole);
    },

    menuItems() {
      let menuItems = [];

      if (this.isUserAuthenticated && this.userRole === "ADMINISTRATOR") {
        menuItems = [
          {
            icon: "credit_card",
            title: "CARTES",
            items: [
              {title: "Liste", link: "/cards/lists"},
              {title: "Historique", link: "/cards/cardhistory"},
              {title: "File d'attente", link: "/cards/cardqueue"},
              {title: "Trafic", link: "/cards/cardcount"}
            ]
          },
          {
            icon: "devices",
            title: "COMMANDES",
            items: [
              {title: "Liste", link: "/commands/lists"},
              {title: "Historique", link: "/commands/commandhistory"},
              {title: "Commandes retardées", link: "/commands/pendingcmd"}
            ]
          },
          {
            icon: "mdi-license",
            title: "LICENCE",
            items: [
              {title: "Licence", link: "/agents/licence"}
            ]
          },
          {
            icon: "mdi-account-arrow-right-outline",
            title: "COMPTES",
            items: [
              {title: "Profil utilisateur", link: "/agents/userprofile"},
              {title: "Agents", link: "/agents/liste_principale"},
              {title: "Détails", link: "/agents/liste_detaillee"},
              {title: "Rôles", link: "/agents/roles"},
              {title: "Brigades", link: "/agents/brigades"},
              {title: "Raisons absence", link: "/agents/raisons_absence"},
              {title: "Génération OTP", link: "/agents/generationcodeemail"},
              {title: "Sécurité", link: "/agents/changecredentials"}
            ]
          },
          {
            icon: "mdi-wallet-bifold-outline ",
            title: "WALLET",
            items: [
              {title: "Entreprises", link: "/wallet/entreprises"},
              {title: "Sites", link: "/wallet/sites"},
              {title: "Terminaux", link: "/wallet/terminaux"},
              {title: "Sessions", link: "/wallet/sessions"},
              {title: "Subventions", link: "/wallet/subventionrules"},
              {title: "Affiliations", link: "/wallet/lienentrepriserestaurant"},
              {title: "Cartes", link: "/wallet/cards"},
              {title: "Cumuls jour", link: "/wallet/montantjourcumul"},
              {title: "Repas", link: "/wallet/nombrerepascumul"},
              {title: "Messages", link: "/wallet/employeemessages"},
              // QR Code retiré d'ici pour les ADMINISTRATOR
              {title: "Jours ouvrés", link: "/wallet/jours-ouvres-admin"},
              {title: "Wallets", link: "/wallet/wallets"}
            ]
          },
          {
            icon: "mdi-currency-usd",
            title: "PAYDUNYA",
            items: [
              {title: "Recharge compte", link: "/paydunya/paymentinitiation"},
              //{title: "PaymentCallback", link: "/paydunya/paymentcallback"},
              //{title: "PaymentSuccess", link: "/paydunya/paymentsuccess"},
              //{title: "PaymentCancel", link: "/paydunya/paymentcancel"}
            ]
          },
          {
            icon: "mdi-camera-timer",
            title: "LOGS",
            items: [
              {title: "Serveurs", link: "/logs/serverlogs"},
              {title: "Audits", link: "/logs/serveraudits"},
              {title: "Clients", link: "/logs/clientslogs"},
              {title: "Alertes", link: "/logs/gestionalertes"},
            ],
          },
          {
            icon: "mdi-devices",
            title: "INFOS TPE",
            items: [
              {title: "Infos remontées", link: "/pointages/infos_tpe"},
              {title: "Statuts constatés", link: "/pointages/statuts_tpe"}
            ],
          },
          {
            icon: "mdi-timetable",
            title: "POINTAGES",
            items: [
              {title: "Pointages Remontés", link: "/pointages/pointages"},
              {title: "Heures Supplémentaires", link: "/agents/heures_sup"},
            ],
          },
          {
            icon: "mdi-altimeter",
            title: "PLANNINGS",
            items: [
              {title: "Planning Présences", link: "/agents/planning_presences"},
              {title: "Planning Absences", link: "/agents/planning_absences"},
              {title: "Planning Brigades", link: "/agents/planning_brigades"},
            ],
          },
          {
            icon: "mdi-card-account-details-star",
            title: "RAPPORTS",
            items: [
              {title: "Présences planifiées", link: "/agents/presences_planifiees"},
              {title: "Présences non planifiées", link: "/agents/presences_non_planifiees"},
              {title: "Absences justifiées", link: "/agents/absences_justifiees"},
              {title: "Absences non justifiées", link: "/agents/absences_non_justifiees"}
            ],
          },
          {
            icon: "mdi-database-cog-outline",
            title: "MODIFICATIONS",
            items: [
              {title: "Journée", link: "/agents/modifs_journees"},
              {title: "Période", link: "/agents/modifs_periodes"},
            ],
          },
          {
            icon: "mdi-ballot-recount-outline",
            title: "PARAMÉTRAGE",
            items: [
              {title: "Shifts personnalisés", link: "/agents/shifts"},
              {title: "Constantes initiales", link: "/agents/constantes"}
            ],
          },
          {
            icon: "mdi-door-closed-lock",
            title: "PERMISSIONS",
            items: [
              {title: "Agents", link: "/agents/permissions_agent"},
              {title: "Groupes", link: "/agents/permissions_groupe"}
            ],
          },
          {
            icon: "mdi-food",
            title: "RESTAURATION",
            items: [
              {title: "Menus", link: "/agents/menus"},
              {title: "Commandes groupées", link: "/agents/commandes"},
              {title: "Commandes multiples", link: "/agents/commandesmultiples"},
              {title: "Rapports salarié *", link: "/agents/rapportssalarieadmin"},
              {title: "Rapports entreprise *", link: "/agents/rapportsentrepriseadmin"},
              {title: "Rapports restaurant *", link: "/agents/rapportsrestaurantadmin"},
              {title: "Transfert commande", link: "/agents/transfertcommande"},
              {title: "Quote parts salariés", link: "/agents/quotepartssalaries"},
              {title: "Stats caissiers", link: "/agents/cashierdailystats"}
            ],
          },
          {
            icon: "mdi-send-lock-outline",
            title: "DISPATCHING",
            items: [
              {title: "Postes", link: "/agents/postes"},
              {title: "Règles", link: "/agents/dispatching_regles"},
              {title: "Fixation", link: "/agents/fixation_agents"},
              {title: "Dispatchings", link: "/agents/dispatching_resultats"},
              {title: "Affectation", link: "/agents/dispatching_resultats_agent"},
              {title: "Affichage ComDePerm", link: "/agents/dispatching_results_comdeperm"}
            ],
          },
        ];
      } else if (this.isUserAuthenticated && this.userRole === "FRONT") {
        menuItems = [
          {
            icon: "credit_card",
            title: "Cards",
            items: [
              {title: "Tous les fonctionnalités", link: "/cards/cmdCards"},
            ],
          },
          {
            icon: "mdi-basket",
            title: "Pending",
            items: [
              {
                title: "Toutes les fonctionnalités",
                link: "/pending/cmdpending",
              },
            ],
          },
        ];
      } else if (this.isUserAuthenticated && this.userRole === "TPE") {
        menuItems = [
          {
            icon: "mdi-devices",
            title: "INFOS TPE",
            items: [
              {title: "Infos", link: "/pointages/infos_tpe"},
              {title: "Statuts", link: "/pointages/statuts_tpe"},
            ],
          },
          {
            icon: "mdi-timetable",
            title: "POINTAGES",
            items: [
              {title: "Pointages Remontés", link: "/pointages/pointages"},
            ],
          }
        ];
      } else if (this.isUserAuthenticated && (this.userRole === "RESTAURATEUR")) {
        menuItems = [
          {
            icon: "mdi-food",
            title: "RESTAURATION",
            items: [
              {title: "Menus", link: "/agents/menus"},
              {title: "Commandes groupées", link: "/agents/commandes"},
              {title: "Rapports entreprise TSA", link: "/agents/rapportsrestaurant"},
              {title: "Stats caissiers", link: "/agents/cashierdailystats"}
            ],
          },
        ];
      } else if (this.isUserAuthenticated && (this.userRole === "POINT FOCAL RESTO")) {
        menuItems = [
          {
            icon: "mdi-food",
            title: "RESTAURATION",
            items: [
              {title: "Menus", link: "/agents/menus"},
              {title: "Commandes groupées", link: "/agents/commandes"},
              {title: "Commandes individuelles", link: "/agents/commandesindividuelles"}
            ],
          },
        ];
      } else if (this.isUserAuthenticated && ((this.userBrigade === "TSA-BRG-MFD") || ((this.userBrigade === "TSA-BRG-ANF")
          || (this.userIdCpt === "91804") || (this.userIdCpt === "92204") || (this.userIdCpt === "19001") || (this.userIdCpt === "20052") || (this.userIdCpt === "92208")
          || (this.userIdCpt === "22014") || (this.userIdCpt === "19129") || (this.userIdCpt === "18046") || (this.userIdCpt === "19385") || (this.userIdCpt === "18108")
          || (this.userIdCpt === "18004") || (this.userIdCpt === "21029") || (this.userIdCpt === "18075") || (this.userIdCpt === "20049")))) {
        menuItems = [
          {
            icon: "mdi-account-arrow-right-outline",
            title: "COMPTES",
            items: [
              {title: "Profil utilisateur", link: "/agents/userprofile"},
              {title: "Agents", link: "/agents/liste_principale"},
              {title: "Détails", link: "/agents/liste_detaillee"},
              {title: "Brigades", link: "/agents/brigades"},
              {title: "Raisons absence", link: "/agents/raisons_absence"},
              {title: "Génération OTP", link: "/agents/generationcodeemail"},
              {title: "Sécurité", link: "/agents/changecredentials"}
            ]
          },
          {
            icon: "mdi-timetable",
            title: "POINTAGES",
            items: [
              {title: "Pointages Remontés", link: "/pointages/pointages"},
              {title: "Heures Supplémentaires", link: "/agents/heures_sup"},
            ],
          },
          {
            icon: "mdi-altimeter",
            title: "PLANNINGS",
            items: [
              {title: "Planning Présences", link: "/agents/planning_presences"},
              {title: "Planning Absences", link: "/agents/planning_absences"},
              {title: "Planning Brigades", link: "/agents/planning_brigades"},
            ],
          },
          {
            icon: "mdi-card-account-details-star",
            title: "RAPPORTS",
            items: [
              {title: "Présences planifiées", link: "/agents/presences_planifiees"},
              {title: "Présences non planifiées", link: "/agents/presences_non_planifiees"},
              {title: "Absences justifiées", link: "/agents/absences_justifiees"},
              {title: "Absences non justifiées", link: "/agents/absences_non_justifiees"}
            ],
          },
          {
            icon: "mdi-database-cog-outline",
            title: "MODIFICATIONS",
            items: [
              {title: "Journée", link: "/agents/modifs_journees"},
              {title: "Période", link: "/agents/modifs_periodes"},
            ],
          },
          {
            icon: "mdi-ballot-recount-outline",
            title: "PARAMÉTRAGE",
            items: [
              {title: "Shifts personnalisés", link: "/agents/shifts"},
              //{title: "Constantes initiales", link: "/agents/constantes"},
            ],
          },
          {
            icon: "mdi-door-closed-lock",
            title: "PERMISSIONS",
            items: [
              {title: "Agents", link: "/agents/permissions_agent"},
              {title: "Groupes", link: "/agents/permissions_groupe"}
            ],
          },
          {
            icon: "mdi-food",
            title: "RESTAURATION",
            items: [
              {title: "Menus", link: "/agents/menus"},
              {title: "Commandes groupées", link: "/agents/commandes"},
              {title: "Commandes individuelles", link: "/agents/commandesindividuelles"}
            ],
          },
          {
            icon: "mdi-send-lock-outline",
            title: "DISPATCHING",
            items: [
              {title: "Postes", link: "/agents/postes"},
              {title: "Règles", link: "/agents/dispatching_regles"},
              {title: "Fixation", link: "/agents/fixation_agents"},
              {title: "Dispatchings", link: "/agents/dispatching_resultats"},
            ],
          },
        ];
      } else if (this.isUserAuthenticated && (this.userRole === "RESPONSABLE MOYENS GÉNÉRAUX")) {
        menuItems = [
          {
            icon: "mdi-account-arrow-right-outline",
            title: "COMPTES",
            items: [
              {title: "Profil utilisateur", link: "/agents/userprofile"},
              {title: "Agents", link: "/agents/liste_principale"},
              {title: "Détails", link: "/agents/liste_detaillee"},
              {title: "Brigades", link: "/agents/brigades"},
              {title: "Raisons absence", link: "/agents/raisons_absence"},
              {title: "Génération OTP", link: "/agents/generationcodeemail"},
              {title: "Sécurité", link: "/agents/changecredentials"}
            ]
          },
          {
            icon: "mdi-timetable",
            title: "POINTAGES",
            items: [
              {title: "Pointages Remontés", link: "/pointages/pointages"},
              {title: "Heures Supplémentaires", link: "/agents/heures_sup"},
            ],
          },
          {
            icon: "mdi-altimeter",
            title: "PLANNINGS",
            items: [
              {title: "Planning Présences", link: "/agents/planning_presences"},
              {title: "Planning Absences", link: "/agents/planning_absences"},
              {title: "Planning Brigades", link: "/agents/planning_brigades"},
            ],
          },
          {
            icon: "mdi-card-account-details-star",
            title: "RAPPORTS",
            items: [
              {title: "Présences planifiées", link: "/agents/presences_planifiees"},
              {title: "Présences non planifiées", link: "/agents/presences_non_planifiees"},
              {title: "Absences justifiées", link: "/agents/absences_justifiees"},
              {title: "Absences non justifiées", link: "/agents/absences_non_justifiees"}
            ],
          },
          {
            icon: "mdi-database-cog-outline",
            title: "MODIFICATIONS",
            items: [
              {title: "Journée", link: "/agents/modifs_journees"},
              {title: "Période", link: "/agents/modifs_periodes"},
            ],
          },
          {
            icon: "mdi-ballot-recount-outline",
            title: "PARAMÉTRAGE",
            items: [
              {title: "Shifts personnalisés", link: "/agents/shifts"},
              //{title: "Constantes initiales", link: "/agents/constantes"},
            ],
          },
          {
            icon: "mdi-door-closed-lock",
            title: "PERMISSIONS",
            items: [
              {title: "Agents", link: "/agents/permissions_agent"},
              {title: "Groupes", link: "/agents/permissions_groupe"}
            ],
          },
          {
            icon: "mdi-food",
            title: "RESTAURATION",
            items: [
              {title: "Menus", link: "/agents/menus"},
              {title: "Commandes groupées", link: "/agents/commandes"},
              {title: "Commandes individuelles", link: "/agents/commandesindividuelles"},
              {title: "Rapports Ndellice", link: "/agents/rapportsndellice"},
              {title: "Rapports MAAY", link: "/agents/rapportsmaay"},
              {title: "Quote parts salariés", link: "/agents/quotepartssalaries"}
            ],
          },
          {
            icon: "mdi-send-lock-outline",
            title: "DISPATCHING",
            items: [
              {title: "Postes", link: "/agents/postes"},
              {title: "Règles", link: "/agents/dispatching_regles"},
              {title: "Fixation", link: "/agents/fixation_agents"},
              {title: "Dispatchings", link: "/agents/dispatching_resultats"},
            ],
          },
        ];
      } else {
        menuItems = [
          {
            icon: "mdi-account-arrow-right-outline",
            title: "COMPTES",
            items: [
              {title: "Profil utilisateur", link: "/agents/userprofile"},
              {title: "Sécurité", link: "/agents/changecredentials"}
            ]
          },
          /*{
            icon: "mdi-qrcode",
            title: "QR CODE",
            items: [
              {title: "QR Code", link: "/wallet/qrcodepayment"},
            ]
          },*/
          {
            icon: "mdi-food",
            title: "RESTAURATION",
            items: [
              {title: "Menus", link: "/agents/menus"},
              {title: "Commandes individuelles", link: "/agents/commandesindividuelles"},
              {title: "Rapports salarié", link: "/agents/rapportssalarie"}
            ],
          },
        ];
      }

      return menuItems;
    },
    isUserAuthenticated() {
      return (
          this.$store.getters.user !== null &&
          this.$store.getters.user !== undefined
      );
    },
    userRole() {
      return this.$store.getters.user.role;
    },
    userBrigade() {
      return this.$store.getters.user.brigade;
    },
    userIdCpt() {
      return this.$store.getters.user.userId;
    },
// NOUVELLES COMPUTED PROPERTIES POUR LES ENVIRONNEMENTS
    isProduction() {
      const baseUrl = this.getbaseUrl;
      return baseUrl === 'https://tsarh.cartaware.cartalink.com';
    },

    isTestEnvironment() {
      const baseUrl = this.getbaseUrl;
      return baseUrl === 'https://tests.eyone.cartaware.cartalink.com';
    },

    isLocalEnvironment() {
      const baseUrl = this.getbaseUrl;
      return baseUrl === 'http://localhost:8082';
    },

    environmentLabel() {
      if (this.isTestEnvironment) return 'TEST';
      if (this.isLocalEnvironment) return 'LOCAL';
      return 'DEV';
    },

    environmentChipColor() {
      if (this.isTestEnvironment) return 'orange';
      if (this.isLocalEnvironment) return 'purple';
      return 'red';
    },

    toolbarBackgroundColor() {
      if (this.isProduction) return '#01579B'; // Bleu original pour production
      if (this.isTestEnvironment) return '#E65100'; // Orange pour test
      if (this.isLocalEnvironment) return '#4A148C'; // Violet pour local
      return '#C62828'; // Rouge pour autres environnements
    },

    toolbarStyle() {
      return {
        background: this.toolbarBackgroundColor,
        'z-index': '300'
      };
    },

    toolbarClass() {
      return {
        'production-toolbar': this.isProduction,
        'test-toolbar': this.isTestEnvironment,
        'local-toolbar': this.isLocalEnvironment,
        'dev-toolbar': !this.isProduction && !this.isTestEnvironment && !this.isLocalEnvironment
      };
    },

    drawerToolbarStyle() {
      return {
        background: this.toolbarBackgroundColor,
        color: 'white',
        'font-weight': 'bold'
      };
    },

    // NOUVELLES COMPUTED PROPERTIES POUR LE DRAWER
    drawerBackgroundColor() {
      if (this.isProduction) return '#F5F5F5'; // Gris clair original pour production
      if (this.isTestEnvironment) return '#FFF3E0'; // Orange très clair pour test
      if (this.isLocalEnvironment) return '#F3E5F5'; // Violet très clair pour local
      return '#FFEBEE'; // Rouge très clair pour autres environnements
    },

    drawerClass() {
      return {
        'production-drawer': this.isProduction,
        'test-drawer': this.isTestEnvironment,
        'local-drawer': this.isLocalEnvironment,
        'dev-drawer': !this.isProduction && !this.isTestEnvironment && !this.isLocalEnvironment
      };
    },

    drawerHeaderClass() {
      return {
        'production-header': this.isProduction,
        'test-header': this.isTestEnvironment,
        'local-header': this.isLocalEnvironment,
        'dev-header': !this.isProduction && !this.isTestEnvironment && !this.isLocalEnvironment
      };
    },

    drawerBandClass() {
      return {
        'test-band': this.isTestEnvironment,
        'local-band': this.isLocalEnvironment,
        'dev-band': !this.isProduction && !this.isTestEnvironment && !this.isLocalEnvironment
      };
    },

    environmentIcon() {
      if (this.isTestEnvironment) return 'mdi-flask';
      if (this.isLocalEnvironment) return 'mdi-laptop';
      return 'mdi-wrench';
    },

    environmentMessage() {
      if (this.isTestEnvironment) return 'Environnement de TEST';
      if (this.isLocalEnvironment) return 'Environnement LOCAL';
      return 'Environnement de DEV';
    }
  },
  created() {
    // Remplacer this.checkPendingUpdate() par :
    this.checkForUpdates();

    // Vérifier l'existence de l'utilisateur avant tout appel API
    const isUserAvailable = sessionStorage.getItem("userId") !== "front" &&
        this.$store.getters.user &&
        this.$store.getters.user.baseUrl;

    if (isUserAvailable) {
      this.loadNotifs();
      this.timer = setInterval(this.loadNotifs, 1800000);

      apiClient
          .get(`${this.$store.getters.user.baseUrl}/account/roles/` + sessionStorage.getItem("userId"))
          .then(response => {
            this.roles = response.data.datas;
          })
          .catch(() => {
          });
    }
  },
  methods: {
    // Nouvelle méthode pour naviguer vers le QR Code
    navigateToQRCode() {
      // Prevent rapid clicks by checking if a navigation is already in progress
      if (this.navigationInProgress) {
        return;
      }

      // Check if we're already on the QR Code route
      if (this.$route.path === '/wallet/qrcodepayment') {
        return;
      }

      // Set flag to prevent concurrent navigations
      this.navigationInProgress = true;

      this.$router.push('/wallet/qrcodepayment')
          .then(() => {
            // Navigation successful
            this.navigationInProgress = false;
            // Close mobile menu after navigation
            if (this.isMobile) {
              this.sideNav = false;
            }
          })
          .catch(err => {
            this.navigationInProgress = false;

            // Handle all common Vue Router navigation errors
            if (err.name === 'NavigationDuplicated') {
              // Silently ignore duplicate navigation
              return;
            }

            if (err.message && err.message.includes('Navigation cancelled')) {
              // Silently ignore cancelled navigation
              return;
            }

            if (err.message && err.message.includes('Navigation aborted')) {
              // Silently ignore aborted navigation
              return;
            }

            // Log only unexpected errors
            console.warn('Unexpected navigation error:', err);
          });
    },

    // Nouvelle méthode pour déclencher la vérification dans le parent
    checkForUpdates() {
      if (this.$parent && typeof this.$parent.triggerUpdateCheck === 'function') {
        this.$parent.triggerUpdateCheck();
      }
    },
    annuler() {
      this.hide();
      this.timerRefreshFront = setInterval(this.checkFrontVersion, this.intervalFrontTimer) // Chaque heure 3600000 - 900000 = 15 min - 300000 = 5 min
    },
    quitComptes() {
      this.showModalComptes = false
      //this.hideComptes();
    },
    quitFonction() {
      this.showModalFonction = false
      //this.hideFunction();
    },
    quitBrigade() {
      this.showModalBrigade = false
      //this.hideBrigade();
    },
    quitRaisonsAbsence() {
      this.showModalRaisonsAbsence = false
      //this.hideRaisonsAbsence();
    },
    quitPlanning() {
      this.showModalPlanning = false
      //this.hidePlanning();
    },
    show() {
      this.$modal.show('modal-fade-info');
    },
    hide() {
      this.$modal.hide('modal-fade-info');
    },
    showComptes() {
      this.showModalComptes = true
      this.showModalFonction = false
      this.showModalBrigade = false
      this.showModalRaisonsAbsence = false
      this.showModalPlanning = false
      //this.$modal.show('modal-fade-comptes');
    },
    hideComptes() {
      this.showModalComptes = false
      //this.$modal.hide('modal-fade-comptes');
    },
    showFunction() {
      this.showModalFonction = true
      this.showModalComptes = false
      this.showModalBrigade = false
      this.showModalRaisonsAbsence = false
      this.showModalPlanning = false
      //this.$modal.show('modal-fade-fonction');
    },
    hideFunction() {
      this.showModalFonction = false
      //this.$modal.hide('modal-fade-fonction');
    },
    showBrigade() {
      this.showModalBrigade = true
      this.showModalComptes = false
      this.showModalFonction = false
      this.showModalRaisonsAbsence = false
      this.showModalPlanning = false
      //this.$modal.show('modal-fade-brigade');
    },
    hideBrigade() {
      this.showModalBrigade = false
      this.$modal.hide('modal-fade-brigade');
    },
    showRaisonsAbsence() {
      this.showModalRaisonsAbsence = true
      this.showModalComptes = false
      this.showModalFonction = false
      this.showModalBrigade = false
      this.showModalPlanning = false
      //this.$modal.show('modal-fade-raisonsabsence');
    },
    hideRaisonsAbsence() {
      this.showModalRaisonsAbsence = false
      //this.$modal.hide('modal-fade-raisonsabsence');
    },
    showPlanning() {
      this.showModalPlanning = true
      this.showModalComptes = false
      this.showModalFonction = false
      this.showModalBrigade = false
      this.showModalRaisonsAbsence = false
      //this.$modal.show('modal-fade-planning');
    },
    hidePlanning() {
      this.showModalPlanning = false
      //this.$modal.hide('modal-fade-planning');
    },
    loadNotifs() {
      // Vérifier si userId est 'front', dans ce cas on quitte la fonction
      if (sessionStorage.getItem("userId") === "front") {
        return;
      }

      // Vérifier si l'utilisateur est connecté et si baseUrl existe
      if (!this.$store.getters.user || !this.$store.getters.user.baseUrl) {
        console.log("Utilisateur non connecté ou URL de base non disponible");
        return;
      }

      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/notification/all/notread/` + sessionStorage.getItem("userId")
          )
          .then(response => {
            this.fullNotifArrayNotRead = [[]];
            this.fullNotifArrayNotRead = response.data.datas;
            this.$store.commit("setNotification", this.fullNotifArrayNotRead.length);
          })
          .catch((error) => {
            console.error("Erreur lors du chargement des notifications:", error);
          });
    },
    isEmpty(str) {
      return (str === null || !str || 0 === str.length || /^\s*$/.test(str));
    },
    checkFrontVersion() {
      console.log("Vérification de version désactivée dans Toolbar - maintenant gérée par App.vue");
    },
    refreshPage() {
      // Appeler la méthode refreshApp d'App.vue si disponible
      if (this.$root && typeof this.$root.refreshApp === 'function') {
        this.$root.refreshApp();
      } else {
        // Fallback si la méthode n'est pas accessible
        window.location.reload();
      }
    },
    setViewedNotif(idNotif) {
      // Vérifier si l'utilisateur est connecté et si baseUrl existe
      if (!this.$store.getters.user || !this.$store.getters.user.baseUrl) {
        console.log("Utilisateur non connecté ou URL de base non disponible");
        return;
      }

      apiClient
          .post(
              `${this.$store.getters.user.baseUrl}/notification/update/true/` + idNotif + "/" + sessionStorage.getItem("userId")
          )
          .then(response => {
            this.loadNotifs()
          })
          .catch(() => {
          });
    },
    displayNotifs() {
      if (!this.$store.getters.user || !this.$store.getters.user.baseUrl) {
        console.log("Utilisateur non connecté ou URL de base non disponible");
        return Promise.reject("Utilisateur non authentifié");
      }

      let bDblClick = false;
      return new Promise((resolve, reject) => {
        if (this.click) {
          bDblClick = true;
          clearTimeout(this.click)

          if ((this.fullNotifArrayNotRead !== null) && (this.fullNotifArrayNotRead.length > 0)) {
            let message = {
              title: 'Fenêtre de confirmation',
              body: 'Confirmez la suppression de toutes les notifications.'
            };

            this.$dialog
                .confirm(message)
                .then(dialog => {
                  bDblClick = false;
                  apiClient
                      .post(
                          `${this.$store.getters.user.baseUrl}/notification/allnotificationsread/` + sessionStorage.getItem("userId") + "/" + sessionStorage.getItem("userId")
                      )
                      .then(response => {
                        dialog.close();
                        this.loadNotifs()
                      })
                      .catch(() => {
                        dialog.close();
                      });
                })
                .catch(() => {
                });
          }
        }

        this.click = setTimeout(() => {
          this.click = undefined

          if (bDblClick)
            return;

          if ((this.fullNotifArrayNotRead !== null) && (this.fullNotifArrayNotRead.length > 0)) {
            let notif = this.fullNotifArrayNotRead.pop()
            this.setViewedNotif(notif.notificationId)

            this.$toast.info(notif.message, {
              position: "top-center",
              timeout: false,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 1,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: "button",
              icon: true,
              rtl: false,
            });
          } else {
            this.$toast.info("Aucune notification disponible !", {
              position: "top-center",
              timeout: false,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 1,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: "button",
              icon: true,
              rtl: false
            });
          }
        }, 300)
      })
    },
    onLogout() {
      this.$store.dispatch("logout").then(() => {
        this.$store.state.loggedIn = false
        this.$router.push("/").catch(err => {
          // Ignore the vuex err regarding  navigating to the page they are already on.
          if (
              err.name !== 'NavigationDuplicated'
          ) {
            // But print any other errors to the console
          }
        });
      });
    },
    redirect(item, index) {
      // Prevent rapid clicks by checking if a navigation is already in progress
      if (this.navigationInProgress) {
        return;
      }

      // Check if we're already on the target route
      if (this.$route.path === item.link) {
        if (this.isMobile) {
          this.sideNav = false;
        }
        return;
      }

      // Set flag to prevent concurrent navigations
      this.navigationInProgress = true;

      this.$router.push(item.link)
          .then(() => {
            // Navigation successful
            this.navigationInProgress = false;
          })
          .catch(err => {
            this.navigationInProgress = false;

            // Handle all common Vue Router navigation errors
            if (err.name === 'NavigationDuplicated') {
              // Silently ignore duplicate navigation
              return;
            }

            if (err.message && err.message.includes('Navigation cancelled')) {
              // Silently ignore cancelled navigation (happens during rapid clicks)
              return;
            }

            if (err.message && err.message.includes('Navigation aborted')) {
              // Silently ignore aborted navigation
              return;
            }

            // Log only unexpected errors
            console.warn('Unexpected navigation error:', err);
          })
          .finally(() => {
            // Close mobile menu after navigation attempt
            if (this.isMobile) {
              this.sideNav = false;
            }
          });
    },
    rndStr(len) {
      let text = "";
      let chars = "abcdefghijklmnopqrstuvwxyz";
      for (let i = 0; i < len; i++) {
        text += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return text;
    },
    slugify(text) {
      return text.toString().toLowerCase()
          .replace(/\s+/g, '-')
          // eslint-disable-next-line no-useless-escape
          .replace(/[^\w\-]+/g, '')
          // eslint-disable-next-line no-useless-escape
          .replace(/\-\-+/g, '-')
          .replace(/^-+/, '')
          .replace(/-+$/, '');
    },
    getLastWordUrl() {
      let ResponseURL = this.currentPage()
      let domain = ResponseURL.split('/');
      return domain[2];
    }
  },
};
</script>

<style>
.v-application a {
  color: #333;
  text-decoration: none;
}

.router-link-active {
  opacity: 1;
  visibility: visible;
  color: #01579B !important;
  font-weight: 700;
  transition: all 0.25s;
  text-decoration: none;
}

.size-modal-content {
  padding: 10px;
  font-style: italic;
}

.v--modal-overlay[data-modal='size-modal'] {
  background: rgba(0, 0, 0, 0.5);
}

.demo-modal-class {
  border-radius: 5px;
  background: #f7f7f7;
  box-shadow: 5px 5px 30px 0px rgba(46, 61, 73, 0.6);
}

.v-btnRefresh {
  margin-left: 50px;
  margin-right: 50px;
}

.v-text-field {
  min-width: 222px;
}

.custom-btn {
  width: 222px;
}

.custom-btn::before {
  color: transparent;
}

.custom-btn:hover {
  color: #F5F5F5 !important;
}

.custom-btn:hover {
  color: #F5F5F5 !important;
}

::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

::v-deep .modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
}

.modal__title {
  margin: 0 2rem 0 0;
  font-size: 1.5rem;
  font-weight: 700;
  color: #01579B;
  text-align: center;
}

.modal__close {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}

.dark-mode div::v-deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}

/* Styles pour les toolbars */
.test-toolbar {
  position: relative;
}

.test-toolbar::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #FF5722, #FF9800, #FFC107);
  z-index: 1;
}

.local-toolbar {
  position: relative;
}

.local-toolbar::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #9C27B0, #673AB7, #3F51B5);
  z-index: 1;
}

.dev-toolbar {
  position: relative;
}

.dev-toolbar::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #F44336, #E91E63, #9C27B0);
  z-index: 1;
}

/* STYLES POUR LE DRAWER (MENU LATÉRAL) */

/* Backgrounds du drawer selon l'environnement */
.test-drawer {
  border-left: 4px solid #FF5722 !important;
}

.local-drawer {
  border-left: 4px solid #9C27B0 !important;
}

.dev-drawer {
  border-left: 4px solid #F44336 !important;
}

/* Headers du drawer */
.test-header {
  background: linear-gradient(135deg, #E65100, #FF5722) !important;
  box-shadow: 0 2px 8px rgba(230, 81, 0, 0.3) !important;
}

.local-header {
  background: linear-gradient(135deg, #4A148C, #9C27B0) !important;
  box-shadow: 0 2px 8px rgba(74, 20, 140, 0.3) !important;
}

.dev-header {
  background: linear-gradient(135deg, #C62828, #F44336) !important;
  box-shadow: 0 2px 8px rgba(198, 40, 40, 0.3) !important;
}

/* Bandes colorées sous l'en-tête */
.test-band {
  height: 6px;
  background: linear-gradient(90deg, #FF5722, #FF9800, #FFC107, #FF9800, #FF5722);
  animation: shimmer 3s ease-in-out infinite;
}

.local-band {
  height: 6px;
  background: linear-gradient(90deg, #9C27B0, #673AB7, #3F51B5, #673AB7, #9C27B0);
  animation: shimmer 3s ease-in-out infinite;
}

.dev-band {
  height: 6px;
  background: linear-gradient(90deg, #F44336, #E91E63, #9C27B0, #E91E63, #F44336);
  animation: shimmer 3s ease-in-out infinite;
}

/* Animation shimmer pour les bandes */
@keyframes shimmer {
  0% {
    background-position: -200% center;
  }
  100% {
    background-position: 200% center;
  }
}

/* Effet sur les éléments de menu dans les environnements non-prod */
.test-drawer .v-list-item:hover {
  background-color: rgba(255, 87, 34, 0.1) !important;
}

.local-drawer .v-list-item:hover {
  background-color: rgba(156, 39, 176, 0.1) !important;
}

.dev-drawer .v-list-item:hover {
  background-color: rgba(244, 67, 54, 0.1) !important;
}

/* Style pour les icônes du menu dans les environnements non-prod */
.test-drawer .v-icon {
  color: #E65100 !important;
}

.local-drawer .v-icon {
  color: #4A148C !important;
}

.dev-drawer .v-icon {
  color: #C62828 !important;
}

/* Animation pour les badges */
.v-chip {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
  100% {
    opacity: 1;
  }
}

/* Style pour le bouton QR Code dans la toolbar */
.v-toolbar .v-btn--text {
  transition: background-color 0.3s ease;
}

.v-toolbar .v-btn--text:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

/* Mobile adaptations */
@media (max-width: 600px) {
  .mobile-toolbar {
    height: 36px !important;
  }

  .mobile-toolbar .v-toolbar__content {
    height: 36px !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .mobile-toolbar .v-chip {
    height: 20px !important;
    font-size: 10px !important;
  }

  /* Style spécifique pour le bouton QR Code en mobile */
  .v-app-bar .v-btn {
    min-width: auto !important;
  }
}
</style>
